<template>
  <transition
    :appear="true"
    mode="in-out"
    @enter="onEnter"
    @leave="onLeave"
  >
    <slot />
  </transition>
</template>

<script setup>
import { animate } from 'motion-v'

const props = defineProps({
  duration: { type: Number, default: 0.3 },
  from: { type: Number, default: 0 },
  to: { type: Number, default: 1 }
})

const onEnter = async (el, done) => {
  await animate(
    el,
    { opacity: [props.from, props.to] },
    { duration: props.duration }
  ).finished
  done()
}

const onLeave = async (el, done) => {
  await animate(el,
    { opacity: [props.to, props.from] },
    { duration: props.duration }
  ).finished
  done()
}
</script>
